module.exports = __webpack_public_path__ + "img/img_mecanica.6bf2172c.webp";